import styled from 'styled-components';

interface ITableRowProps {
  borderTop?: string;
}

export const TableRow = styled.tr<ITableRowProps>`
  border-top: ${props => props.borderTop || 'auto'};
`;